import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
    signature: '',
  },
};

for (let i = 0; i < 21; i++) {
  initialState.data[`windowOptionInput${i + 1}`] = '';
}

initialState.data['windowOptionInput14'] = 'NO GRIDS';

export const windowoptionSlice = createSlice({
  name: 'windowoption',
  initialState,
  reducers: {
    updateValue: (state, action) => {
      state.data[action.payload.id] = action.payload.count || '';
    },
    updateDataWindowoption: (state, action) => {
      state.data = action.payload;
    },
    init: (state, action) => {
      state.data = initialState.data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateValue, updateDataWindowoption, init } =
  windowoptionSlice.actions;

export default windowoptionSlice.reducer;
